/* Kubota Meet the Tastemakers — entrance animation observer.

   One-shot IntersectionObserver. Adds `.mtt-in-view` to the section when its
   top crosses 30% above the viewport bottom (i.e. enters the top 70% of the
   viewport). CSS transitions per [data-anim] child use `--i` for stagger.
   Mirrors the kubota-in-the-glass.js pattern. */

(() => {
  const init = () => {
    const sections = document.querySelectorAll(
      '.kubota-meet-the-tastemakers[data-entrance]:not([data-entrance="none"])'
    );
    if (!sections.length) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach((section) => {
      if (reduce) {
        section.classList.add('mtt-in-view');
        return;
      }

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            section.classList.add('mtt-in-view');
            io.unobserve(section);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -30% 0px' }
      );
      io.observe(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
